import { get } from 'lodash-es';

/**
 * Gets available digital retails product programs.
 * @param {object} inventory
 * @returns {{leaseProgram: string, loanProgram: string}}
 */
export function getDigitalRetailAvailablePrograms(inventory) {
  const { lease, loan } = get(inventory, 'dealerInfo.productFeatures.digitalRetail', {});
  const leaseProgram = get(lease, 'program', '');
  const loanProgram = get(loan, 'program', '');

  return {
    leaseProgram,
    loanProgram,
  };
}
